var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"eronet-logo",attrs:{"src":require('@/assets/img/eronet-logo.png'),"width":"50","alt":"HT Eronet"}})}
var staticRenderFns = []

export { render, staticRenderFns }